/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { createStyles, makeStyles, Theme } from '@material-ui/core';

const EntryContentViewStyles = makeStyles((theme: Theme) =>
	createStyles({
		header: {
			marginTop: theme.spacing(3),
			display: 'flex',
			height: '35px',
		},
		titleContainer: {
			marginTop: 'auto',
			marginBottom: 'auto',
			flexGrow: 1,
		},
		title: {
			fontSize: '18px',
		},
		subTitle: {
			fontSize: '14px',
			color: 'black',
		},
		headerButtons: {
			display: 'flex',
			justifyContent: 'flex-end',
		},
		publishButton: {
			maxHeight: '35px',
			marginTop: 'auto',
			marginBottom: 'auto',
			borderColor: theme.palette.secondary.main,
			opacity: '0.7',
			borderWidth: '2px',
			'&:hover': {
				backgroundColor: '#e9e9e9',
			},
		},
		buttonLabel: {
			color: theme.palette.secondary.main,
		},
		cancelButton: {
			padding: '0px',
			height: '24px',
			marginLeft: theme.spacing(1),
			marginTop: 'auto',
			marginBottom: 'auto',
		},
		headerInfoContainer: {
			marginTop: theme.spacing(4),
			display: 'flex',
		},
		headerInfoText: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'space-between',
		},
		courseName: {
			fontSize: '1.0625rem',
		},
		studentImage: {
			borderRadius: '50%',
			height: '48px',
			width: '48px',
			marginRight: theme.spacing(2),
			objectFit: 'cover',
		},
		contentContainer: {
			height: '100%',
		},
		contentLeft: {
			height: '100%',
		},
		contentRight: {
			display: 'flex',
			flexDirection: 'column',
			height: '100%',
			padding: theme.spacing(0, 4),
		},
		contentRoot: {
			'&:first-child': {
				paddingTop: theme.spacing(1),
			},
		},
		content: {
			padding: theme.spacing(1, 0, 0),
			overflowY: 'auto',
			flexGrow: 1,
		},
		thumbContainer: {
			margin: theme.spacing(2, 0),
			justifyContent: 'flex-end',
		},
		thumbBox: {
			'& svg': {
				width: '16px',
				marginRight: theme.spacing(1),
			},
			'& button': {
				padding: theme.spacing(1, 1),
				borderRadius: theme.spacing(1),
			},
		},
		rejectButton: {
			color: '#F4430B',
			'& svg': {
				opacity: 0.7,
			},
			'& p': {
				color: '#F4430B',
				fontFamily: theme.typography.fontFamilyBold,
			},
			'&:hover': {
				backgroundColor: '#e9e9e9',
			},
		},
		approveButton: {
			backgroundColor: '#188F06',
			color: '#FFFFFF',
			'& p': {
				color: '#FFFFFF',
				fontFamily: theme.typography.fontFamilyBold,
			},
			'&:hover': {
				backgroundColor: '#2b801e',
			},
		},
		requestContainer: {
			display: 'flex',
			justifyContent: 'space-between',
			margin: theme.spacing(2, 0),
		},
		requestPublicationButton: {
			'& .MuiTypography-body1': {
				fontFamily: theme.typography.fontFamilyBold,
				color: '#FFFFFF',
			},
		},
		checkboxContainer: {
			display: 'flex',
			alignItems: 'center',
		},
		checkbox: {
			width: '24px',
			height: '24px',
			marginRight: theme.spacing(1),
			padding: 0,
			'& .MuiSvgIcon-root': {
				width: '32px',
				height: '32px',
				color: '#121003',
			},
		},
		checkboxLabel: {
			lineHeight: '24px',
		},
	})
);

export default EntryContentViewStyles;
